module.exports = __webpack_public_path__ + "static/media/lock-avax.56f18210.svg";